"use client";

import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";

export const redirectWithDelay = (
  router: AppRouterInstance,
  redirectUrl: string,
) => {
  // Helper function to resolve if URL is internal
  const getNavigationUrl = (inputUrl: string): string => {
    try {
      const currentOrigin = window.location.origin;
      const parsed = new URL(inputUrl, currentOrigin);
      if (parsed.origin === currentOrigin) {
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return inputUrl;
    } catch {
      return inputUrl;
    }
  };

  setTimeout(() => {
    const target = getNavigationUrl(redirectUrl);
    if (typeof window !== "undefined" && window.newrelic) {
      window.newrelic.addPageAction("redirectWithDelay.target", {
        target,
      });
    }
    if (target.startsWith("/")) {
      router.push(target);
    } else if (target.startsWith("http")) {
      window.location.assign(target);
    } else {
      router.push(target);
    }
  }, 1000);
};
